<div class="ui-grid-row" *ngIf="data && data.length == 0">
    <div class="ui-messages ui-widget ui-corner-all ng-tns-c4-2 ui-messages-warn ng-trigger ng-trigger-messageAnimation ng-star-inserted" role="alert" style="transform: translateY(0px); opacity: 1;">
        <a class="ui-messages-close ng-tns-c4-2 ng-star-inserted" tabindex="0" style=""></a>
        <span class="ui-messages-icon pi pi-exclamation-triangle"></span>
        <ul class="ng-tns-c4-2">
            <li class="ng-tns-c4-2 ng-star-inserted" style="">
                <span class="ui-messages-summary ng-tns-c4-2 ng-star-inserted">{{message}}</span>
            </li>
        </ul>
    </div>
</div>
